export default __webpack_public_path__ + "static/media/logo.a372a018.svg";